module.exports = __webpack_public_path__ + "img/sled-frame-factory.bb98cac0.webp";